var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_72",
    "data-name": "Group 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 20,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M19.959,1.92a8.531,8.531,0,0,1-2.358.646A4.069,4.069,0,0,0,19.4.3a8.177,8.177,0,0,1-2.595.99,4.092,4.092,0,0,0-7.078,2.8,4.213,4.213,0,0,0,.095.933A11.582,11.582,0,0,1,1.39.746,4.093,4.093,0,0,0,2.647,6.215,4.041,4.041,0,0,1,.8,5.711v.045A4.111,4.111,0,0,0,4.077,9.776,4.084,4.084,0,0,1,3,9.911a3.618,3.618,0,0,1-.775-.07,4.131,4.131,0,0,0,3.823,2.85A8.222,8.222,0,0,1,.979,14.437,7.664,7.664,0,0,1,0,14.381a11.52,11.52,0,0,0,6.277,1.836A11.566,11.566,0,0,0,17.923,4.573c0-.181-.006-.356-.015-.529A8.163,8.163,0,0,0,19.959,1.92",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterW);
export default __webpack_public_path__ + "static/media/Twitter-W.c757e97199e244356b9cece13ca6c325.svg";
export { ForwardRef as ReactComponent };